import { useMemo } from 'react'

import config from 'constants/config'

export const useTourV2SearchEnabled = () => {
  return useMemo(() => config.TOUR_V2_SEARCH_ENABLED, [])
}
